import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Statement } from "@/components/Statement";
import { Philosophy } from "@/components/Philosophy";
import { Commentary } from "@/components/Commentary";
import { Technology } from "@/components/Technology";
import { NextGeneration } from "@/components/NextGeneration";
import { Archive } from "@/components/Archive";
import { Observations } from "@/components/Observations";
import { About } from "@/components/About";
import { FeaturedPiece } from "@/components/FeaturedPiece";
import { Blog } from "@/components/Blog";
import { SpeakingCTA } from "@/components/SpeakingCTA";
import { Final } from "@/components/Final";
import { useContent } from "@/content";

const DEFAULT_STATEMENTS = [
  { label: "MY MOTTO", text: "LIVE, GROW, AND APPLY." },
  { label: "", text: "DO NOT OUTSOURCE YOUR MIND." },
  { label: "", text: "THE ALGORITHM DOES NOT GET TO DEFINE YOU." },
  { label: "", text: "BOREDOM IS NOT THE ENEMY." },
  { label: "", text: "I AM STILL BECOMING." },
  { label: "", text: "QUESTION WHAT EVERYONE ELSE CALLS NORMAL." },
  { label: "", text: "YOUR MIND IS YOUR GREATEST ASSET." },
  { label: "", text: "I LIVE FOR MY SOUL NOT FOR SOCIETY." },
];

const StatementSlot = ({ item }) =>
  item && item.text && item.text.trim() ? (
    <Statement text={item.text} label={item.label || undefined} />
  ) : null;

export default function Home() {
  const c = useContent();
  const st = Array.isArray(c.statements) && c.statements.length ? c.statements : DEFAULT_STATEMENTS;

  return (
    <main className="relative bg-[#05070F] text-[#F8F8F8]">
      <div className="aura-field" aria-hidden="true" />
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <StatementSlot item={st[0]} />
      <Philosophy />
      <StatementSlot item={st[1]} />
      <Commentary />
      <StatementSlot item={st[2]} />
      <Technology />
      <StatementSlot item={st[3]} />
      <NextGeneration />
      <StatementSlot item={st[4]} />
      <FeaturedPiece />
      <SpeakingCTA />
      <Archive />
      <StatementSlot item={st[5]} />
      <Observations />
      <Blog />
      <StatementSlot item={st[6]} />
      <StatementSlot item={st[7]} />
      <Final />
    </main>
  );
}
